import { render, staticRenderFns } from "./RoyaltiesComputeManagement.vue?vue&type=template&id=837fc5ba&scoped=true"
import script from "./RoyaltiesComputeManagement.vue?vue&type=script&lang=js"
export * from "./RoyaltiesComputeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837fc5ba",
  null
  
)

export default component.exports